import {
  AppointmentResponse,
  ResponseDetails,
} from "@smart/bridge-types-basic";
import { Icon } from "@smart/itops-sb-design-system-dom";
import { displayAppointmentValues } from "@smart/itops-utils-basic";

import { FieldItem } from "../../types";
import { getUITranslation } from "../../utils/ui-translations";
import {
  AppointmentFieldWrapper,
  getAppointmentDuration,
  getAppointmentTimezoneOptions,
  getIntakeMeetingTypeLabel,
} from "../field-components";

export const SummaryAppointment = ({
  field,
  response,
  responseDetails,
  selectedLanguage,
}: {
  field: FieldItem;
  response: AppointmentResponse | undefined;
  responseDetails?: ResponseDetails;
  selectedLanguage?: string;
}) => {
  const { bookedStaff, startTime, endTime, timezone, status } = response || {};
  const isValid = status && status !== "invalid" && bookedStaff?.length;
  const date = displayAppointmentValues({
    startTime,
    endTime,
    timezone,
    dayFormat: "dd MMM yyyy",
  });

  return (
    <AppointmentFieldWrapper
      id=""
      errorId=""
      field={field}
      responseDetails={responseDetails}
    >
      {isValid ? (
        <div className="flex flex-col gap-large p-[2.4rem] text-ui">
          <div className="flex flex-col gap-xSmall">
            <div className="font-semibold">
              {getUITranslation(
                "appointmentSelectedAttendee",
                selectedLanguage,
              )}
            </div>
            <div>
              {[
                bookedStaff[0].firstName,
                bookedStaff[0].middleName,
                bookedStaff[0].lastName,
              ]
                .filter(Boolean)
                .join(" ")}
            </div>
          </div>
          <div className="flex flex-col gap-medium">
            <div className="flex flex-col gap-xSmall">
              <div className="font-semibold">
                {getUITranslation("appointmentTimezone", selectedLanguage)}
              </div>
              <div>
                {
                  getAppointmentTimezoneOptions().find(
                    (tz) => tz.tzCode === timezone,
                  )?.label
                }
              </div>
            </div>
            <div className="flex items-center gap-small">
              <Icon name="lightClock" />
              <span className="text-paragraph">
                {getAppointmentDuration(
                  field.duration || 0,
                  field.durationUnit,
                  selectedLanguage,
                )}
              </span>
            </div>
            <div className="flex items-center gap-small">
              <Icon name="lightMobile" />
              <span className="text-paragraph">
                {getIntakeMeetingTypeLabel(
                  field.meetingType || "inPerson",
                  selectedLanguage,
                )}
              </span>
            </div>
          </div>
          <div className="flex flex-col gap-xSmall">
            <div className="font-semibold">
              {getUITranslation("appointmentDate", selectedLanguage)}
            </div>
            <div>{date.day}</div>
          </div>
          <div className="flex flex-col gap-xSmall">
            <div className="font-semibold">
              {getUITranslation("appointmentTime", selectedLanguage)}
            </div>
            <div>{date.startTimeString}</div>
          </div>
        </div>
      ) : (
        <p className="text-ui p-[2.4rem]">
          {getUITranslation("appointmentNoAppointmentMade", selectedLanguage)}
        </p>
      )}
    </AppointmentFieldWrapper>
  );
};
